import {
  ACCEPTED_MEDIA_TYPES,
  ACCEPTED_FLOORPLANS_TYPE,
} from '@/features/estate-media/schema/upload-media';

const ACCEPTED_FLOOR_PLAN_MIME_TYPES = [
  ACCEPTED_MEDIA_TYPES.Jpeg,
  ACCEPTED_MEDIA_TYPES.Jpg,
  ACCEPTED_MEDIA_TYPES.Png,
  ACCEPTED_MEDIA_TYPES.Pdf,
];

export const getFileKey = (file: File) =>
  `${file.name}-${file.size}-${file.lastModified}-${file.type}`;

export const formatFileSize = (size: number) => `${(size / 1024 / 1024).toFixed(2)} MB`;

export const isAcceptedFloorPlanFile = (file: File) => {
  const fileExtension = file.name.split('.').pop()?.toLowerCase();

  return Boolean(
    fileExtension &&
      ACCEPTED_FLOORPLANS_TYPE.includes(fileExtension) &&
      (file.type === '' || ACCEPTED_FLOOR_PLAN_MIME_TYPES.includes(file.type))
  );
};
